import PerDiem from "@/model/PerDiem";
import OrderName from "@/model/OrderName";
import EmployeeName from "@/model/EmployeeName";

export default class PerDiemDetailsDialogParameters {
    public date!: string;

    public employees: Array<EmployeeName> = new Array<EmployeeName>();

    public perDiem: PerDiem;

    public orders: Array<OrderName> = new Array<OrderName>();

    /**
     * Saves the per diems through the order's per diem API, which everyone with access to the order may use, instead
     * of the employee's.
     */
    public saveForOrder = false;
}
